'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _dec3, _class; // Lib


// Selectors


// Components


// Measurements


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _recompose = require('recompose');

var _elementSelector = require('../elementSelector');

var _lineSelector = require('./lineSelector');

var _Line = require('./Line');

var _Line2 = _interopRequireDefault(_Line);

var _measurementsConnect = require('../../components/measurements/measurementsConnect');

var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);

var _measurementsSelector = require('../../components/measurements/measurementsSelector');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO Return only the required measurements (the ones that the line edges require)
var mapMeasurementsStateToProps = function mapMeasurementsStateToProps(connectionsState) {
    return {
        measurements: (0, _measurementsSelector.getMeasurementsMap)(connectionsState)
    };
};

var makeMapStateToProps = function makeMapStateToProps() {
    return (0, _reselect.createSelector)(_elementSelector.getElementId, (0, _lineSelector.makeGetEdgesPx)(), _elementSelector.getColourHex, _lineSelector.getLineStartStyle, _lineSelector.getLineEndStyle, _lineSelector.getIsLineStartSnapped, _lineSelector.getIsLineEndSnapped, function (state, ownProps) {
        return ownProps.isPresentational;
    }, function (elementId, _ref, colorHex, startStyle, endStyle, startSnapped, endSnapped, isPresentational) {
        var start = _ref.start,
            end = _ref.end,
            startEdgeOrigin = _ref.startEdgeOrigin,
            endEdgeOrigin = _ref.endEdgeOrigin,
            controlPoint = _ref.controlPoint,
            startConnectionRect = _ref.startConnectionRect,
            endConnectionRect = _ref.endConnectionRect;
        return {
            elementId: elementId,
            start: start,
            end: end,
            startConnectionRect: startConnectionRect,
            endConnectionRect: endConnectionRect,
            startEdgeOrigin: startEdgeOrigin,
            endEdgeOrigin: endEdgeOrigin,
            controlPoint: controlPoint,
            colorHex: colorHex,
            startStyle: startStyle,
            endStyle: endStyle,
            startSnapped: startSnapped && !isPresentational,
            endSnapped: endSnapped && !isPresentational
        };
    });
};

var LinePresentationalWrapper = (_dec = (0, _measurementsConnect2.default)(mapMeasurementsStateToProps), _dec2 = (0, _recompose.shouldUpdate)(function (props, nextProps) {
    return !nextProps.isPresentational;
}), _dec3 = (0, _reactRedux.connect)(makeMapStateToProps), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
    _inherits(LinePresentationalWrapper, _React$Component);

    function LinePresentationalWrapper() {
        _classCallCheck(this, LinePresentationalWrapper);

        return _possibleConstructorReturn(this, (LinePresentationalWrapper.__proto__ || Object.getPrototypeOf(LinePresentationalWrapper)).apply(this, arguments));
    }

    _createClass(LinePresentationalWrapper, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                cacheEdges = _props.cacheEdges,
                start = _props.start,
                end = _props.end;

            if (cacheEdges) {
                cacheEdges({ start: start, end: end });
            }

            return _react2.default.createElement(_Line2.default, this.props);
        }
    }]);

    return LinePresentationalWrapper;
}(_react2.default.Component)) || _class) || _class) || _class);


LinePresentationalWrapper.propTypes = {
    cacheEdges: _propTypes2.default.func,
    start: _propTypes2.default.object,
    end: _propTypes2.default.object,
    isPresentational: _propTypes2.default.bool
};

exports.default = LinePresentationalWrapper;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/LinePresentationalWrapper.js
// module id = 736
// module chunks = 0